// extracted by mini-css-extract-plugin
export default {"tooltipDetailsContainer":"Tooltip_tooltipDetailsContainer__M1oA-","tooltipDetailsContainerHidden":"Tooltip_tooltipDetailsContainerHidden__RUn9V"};